export function linearInterpolate(
  x: number,
  xp: number[],
  fp: number[],
): number {
  const n = xp.length;
  if (n === 0 || fp.length !== n) return NaN;
  if (n === 1 || x <= xp[0]) return fp[0];
  if (x >= xp[n - 1]) return fp[n - 1];

  for (let i = 0; i < n - 1; i++) {
    if (x <= xp[i + 1]) {
      const t = (x - xp[i]) / (xp[i + 1] - xp[i]);
      return fp[i] + t * (fp[i + 1] - fp[i]);
    }
  }
  return fp[n - 1];
}
